import { useEffect, useRef, useState } from "react";

function BackgroundAudio() {
  const audioRef = useRef(null);
  const [muted, setMuted] = useState(false);
  const [needsInteraction, setNeedsInteraction] = useState(false);

  useEffect(() => {
    const audio = new Audio("/assets/Sound.mp3"); // Now from public folder ✅
    audio.loop = true;
    audio.volume = 0.4;
    audioRef.current = audio;

    audio
      .play()
      .then(() => {
        console.log("🎶 Background audio started.");
      })
      .catch(() => {
        console.warn("🎧 Autoplay blocked. Waiting for user interaction.");
        setNeedsInteraction(true);
      });

    return () => {
      audio.pause();
    };
  }, []);

  const startAudio = () => {
    if (audioRef.current) {
      audioRef.current.play();
      setNeedsInteraction(false);
    }
  };

  const toggleMute = () => {
    if (audioRef.current) {
      audioRef.current.muted = !muted;
      setMuted(!muted);
    }
  };

  return (
    <div className="fixed bottom-4 right-4 flex gap-2 items-center z-50">
      {needsInteraction && (
        <button
          onClick={startAudio}
          className="bg-green-600 text-white px-3 py-1 rounded shadow text-sm"
        >
          🔊 Start Sounds
        </button>
      )}
      <button
        onClick={toggleMute}
        className="bg-green-700 text-white px-3 py-1 rounded shadow text-sm"
      >
        {muted ? "🔇 Sound Off" : "🔉 Sound On"}
      </button>
    </div>
  );
}

export default BackgroundAudio;
